import { BUSCAR_REGRA_BILHETE } from '../../actions/types'

const initialState = []

export default function reducerBuscarRegraBilhete (state = initialState, action) {
  switch (action.type) {
    case BUSCAR_REGRA_BILHETE: {
      return action.payload.data;
    }
    default: {
      return state
    }
  }
}
